import { PageHeader } from "@/components/dash";
import { ChangePassword } from "@/components/ChangePassword";

export default function AdminSettings() {
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="CMS · Settings" title="Account settings" desc="Change the admin password. A 6-digit code is sent to the admin alert email, and all other devices are signed out after the change." />
      <ChangePassword />
    </div>
  );
}
